const formatPhoneUS = (value) => {
    // Remove +1 if it exists at the start
    if (value.startsWith('+1')) {
        value = value.substring(2);
    }

    // Remove all non-digit characters
    const cleaned = ('' + value).replace(/\D/g, '');

    // If the length is less than or equal to 4, return it as is
    if (cleaned.length <= 3) {
        return cleaned;
    }

    // Check if the input is of correct length or partially complete
    const match = cleaned.match(/^(\d{3})(\d{1,3})?(\d{0,4})?$/);

    if (match) {
        const part1 = `(${match[1]})`; // Area code
        const part2 = match[2] || ''; // First part of local number
        const part3 = match[3] || ''; // Second part of local number

        return `${part1} ${part2}${part3 ? `-${part3}` : ''}`;
    }

    return cleaned;
};

export default formatPhoneUS;
